<template>
  <div class="knowledge_box">
    <ArawerCard></ArawerCard>
    <div class="draggable-btn" ref="draggableBtn" @mousedown="startDrag">
      <p @click="setCurrent($event)">一键加购</p>
      <!-- <img src="@/assets/headerimage/yjjrcard.png" alt="拖拽按钮"> -->
    </div>
    <!-- 知识库主题列表和卡片列表 -->
    <div class="knowledge-container" v-loading="loading1">
      <!-- 左侧导航列表 -->
      <div class="knowledge-nav">
        <div
          style="
            padding: 10px 0px 0 30px;
            font-weight: 500;
            font-size: 21px;
            color: #333333;
          "
        >
          <div class="cpfl_header_icon">
            <img :src="yyly_icon" alt="" />
            <p
              style="
                font-size: 18px;

                font-weight: 500;
                text-align: CENTER;
              "
            >
              应用领域
            </p>
          </div>
          <p
            style="
              font-weight: 400;
              font-size: 12px;
              color: #999;
              margin-top: 4px;
              padding-left: 21px;
            "
          >
            共收录：{{ totalValue }}
          </p>
        </div>
        <el-menu
          class="nav-menu"
          :default-active="activeNav"
          @select="handleNavSelect"
        >
          <el-menu-item
            v-for="(item, index) in Licationnav"
            :key="index"
            :index="item.id"
            class="know_nav"
            :class="{ active: activeNav === item.id }"
          >
            <span>
              {{ item.name
              }}
         
              
              </span
            >
          </el-menu-item>
        </el-menu>
      </div>
      <!-- 右侧卡片列表 -->
      <div class="knowledge-cards">
        <div>
          <el-table
            :show-header="false"
            :data="filteredKnowledgeCards"
            @selection-change="handleSelectionChange"
            @select-all="handleall"
            ref="tableRef"
            :header-cell-class-name="headerCellStyle"
            :row-class-name="tableRowClassName"
            v-loading="loading"
          >
            <!-- <el-table-column type="selection" width="25px" /> -->
            <el-table-column  prop="titleHtml" width="1145px"  >
              <template #default="scope">
                <div class="knowdegritem">
                  <img
                    style="width: 160px; height: 90px;border: 1px solid #ebeef5;"
                    :src="getImagePath2(scope.row.imgUrl)"
                    @mouseenter="showBigImg(scope.row.imgUrl, $event)"
                    @click="showBigImg(scope.row.imgUrl, $event)"
                    @mouseleave="hideBigImg(scope.row.imgUrl, $event)"
                    alt=""
                    v-if="scope.row.imgUrl"
                  />
                  <div class="knowdege_center" :class="!scope.row.imgUrl?'knowdege_center1':''">
                    <div class="knoedege_text_cont" :class="{knoedege_text_cont1:!scope.row.imgUrl}">
                      <div class="knowdegList_title">
                        <p
                          @click="datebaseinfo(scope.row)"
                          v-html="scope.row.title"
                          :title="scope.row.title"
                        ></p>
                        <!-- <div>HOT</div> -->
                      </div>

                      <div>
                        <p
                          :title="stripHtmlTags(scope.row.description)"
                          class="description-text"
                          v-html="scope.row.description || '暂无简介'"
                        ></p>
                      </div>
                      <div class="knoedege_fwfs">
                        <div>网络访问</div>
                        <div>镜像访问</div>
                        <div
                          @click="handlejpzskinffo(scope.row, $event)"
                          class="knowdege_jianjie"
                        >
                          简介
                        </div>
                      </div>
                    </div>
                    <div class="knowdege_but">
                      <div class="but_count" v-show="scope.row.useCount&&scope.row.useCount!=0">
                        使用量:{{ scope.row.useCount }}
                      </div>
                      <div
                        class="but_addcard"
                        @click="triggerParentEvent(scope.row, $event)"
                      >
                        加入采购清单
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <transition name="fade">
            <div
              v-if="jzzsktype"
              class="overlay"
              @click="handlejpzskinffo"
            ></div>
          </transition>

          <transition name="popover">
            <div
              class="zpzsk_Popover"
              v-if="jzzsktype"
              :style="{
                position: 'absolute',
                top: `${clickPosition.top}px`,
                left: `${clickPosition.left}px`,
                transform: 'translateX(-50%)',
              }"
            >
              <p class="jpzsk_title">{{ currentItem?.title }}</p>
              <p
                class="jpzsk_content"
                v-html="currentItem?.description || '暂无简介'"
              ></p>
            </div>
          </transition>
          <transition name="fade">
            <div class="image-box-viewer" id="imageBoxViewer" :style="{top: `${imgPosition.top}px`,
                  left: `${imgPosition.left}px`, border: 'none',position: 'absolute',width:'950px',zIndex:'99'}" v-if="bigImgVisable">
              <div class="viewer-image" style="box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);">
                <!-- <div class="load" style="display: none;">
                  <span class="load-icon"></span>
                </div> -->
                <img style="width: 100%;" :src="bigImg"  />
              </div>
            </div>
          </transition>
          <div
            class="kongEmpoty"
            v-if="filteredKnowledgeCards.length === 0 && searchComplete"
          >
            <div class="kongEmpotyimg">
              <img :src="kongzt" alt="" />
              <div class="kongEmpotytext">
                <p>
                  您搜索的知识库平台暂未收录，我们的小伙伴们正在抓紧时间搜录，如果您有相关的知识库推荐，<span
                    @click="handlecooperation"
                    >联系我们</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="pageClass" v-if="counttotal > 0">
            <el-pagination
              :page-size="pageSize"
              :pager-count="count"
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :total="counttotal"
              :current-page="currentPage"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- <el-footer>
      <AppFooter></AppFooter>
    </el-footer> -->
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onUnmounted, watch,onBeforeUnmount } from "vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import CustomPopover from "@/views/components/CustomPopover.vue";

// import { defineProps } from "vue";
import { useRouter, useRoute } from "vue-router";
import {
  Search,
  ShoppingCart,
  ArrowLeft,
  ArrowRight,
} from "@element-plus/icons-vue";
import {
  PostselectKnowledgeBaseList,
  PostUserCarList,
  getBuyLog,
    PostBusInessKnmwList,

} from "@/api/index.js";
import { Cookie } from "@/utils/Cookie";
import kongzt from "@/assets/headerimage/shoppingImage.png";
import cpfl from "@/assets/newimages/cpfl.png";
import ArawerCard from "@/views/components/ArawerCard.vue";
import imagecard from "@/assets/image/newcard.png";
import yyly_icon from "@/assets/image/yyly_icon.png";
import bus from "@/mitt/bus.js";
import { ElMessage } from "element-plus";
import { usePageStayTime } from "@/utils/usePageStayTime";
const { stayTime, totalStayTimes } = usePageStayTime();
const tableRef = ref(null);
const loading1 = ref(false);
const searchComplete = ref(false);
const loading = ref(true)
const router = useRouter();
const route = useRoute();
const currentPage = ref(1);
const pageSize = ref(6);
const counttotal = ref(0);
const totalValue = ref(0);
const filteredKnowledgeCards = ref([]);
const currentItem = ref([]);
const searchQuery = ref("");
const selectAll = ref(false);
const selectedRows = ref([]);
const lableBtnRef = ref(null);
const isDragging = ref(false);

const jzzsktype = ref(false);
const clickPosition = ref({
  top: 0,
  left: 0,
  width: 0,
});
const imgPosition = ref({
  top: 0,
  left: 0,
  width: 0,
});
const weburl = ref(window.location.href);
const bigImg = ref(null)
const bigImgVisable = ref(false);

// const activeNav = ref('396');

const activeNav = ref(route.query.id2 || "396");

const Licationnav = ref([
    {
        id:'396',
        name:'政府部门'
    },
    {

          id:'397',
        name:'科研单位'
    },
    {
          id:'398',
        name:'公共图书馆'
    },
    {
          id:'399',
        name:'高校图书馆'
    },
])

const fetchBusinessData = async (id) => {
  loading.value = true
  const res = await PostBusInessKnmwList({ bussinessCid: id,pageSize:'6',pageIndex:'1' });
  if (res?.info) {
    filteredKnowledgeCards.value = res.info;
     totalValue.value = res.info.length;
     loading.value = false
  }
};

const showBigImg = (url, event) => {
  // debugger
  const clickElement = event.currentTarget;
  const rect = clickElement.getBoundingClientRect();
  
  // 创建临时图片获取尺寸
  const tempImg = new Image();
  tempImg.src = getImagePath2(url);
  
  tempImg.onload = () => {
    const imgWidth1 = tempImg.width;
    const imgHeight1 = tempImg.height;

    const imgWidth = 950;
    const imgHeight = Math.ceil((imgHeight1*950)/imgWidth1);
    
    // 获取视口尺寸
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    
    let left = rect.left + window.scrollX - imgWidth - 10; 
    
    if (left < window.scrollX) {
      left = rect.right + window.scrollX + 10; 
    }
    
    // 垂直居中对齐触发元素
    let top = rect.top + window.scrollY;
    
     // 确保图片不超出视口顶部
    // if (top < window.scrollY) {
    //   // top = window.scrollY + 15;
    //   top = rect.top - 100;
    // }
    
    // 确保图片不超出视口底部
    if (rect.top > viewportHeight - imgHeight) {
      // top = rect.top - (top+imgHeight-viewportHeight) -rect.bottom;

      top =rect.top + window.scrollY-136  -(imgHeight - (viewportHeight- rect.top));
    }
    else{
      top = top - 130;
    }
    
    imgPosition.value = {
      top,
      left,
      width: imgWidth,
    };
    
    bigImg.value = getImagePath2(url);
    bigImgVisable.value = true;
  };
  
  tempImg.onerror = () => {
    console.error('图片加载失败:', url);
    // 可以显示默认图片或错误提示
  };
};

const hideBigImg = ()=>{
  bigImgVisable.value = false;
}

const handlejpzskinffo = (row, event) => {
  currentItem.value = row;
  jzzsktype.value = !jzzsktype.value;

  // 保存点击位置信息
  if (jzzsktype.value) {
    const clickElement = event.currentTarget;
    const rect = clickElement.getBoundingClientRect();
    clickPosition.value = {
      top: rect.bottom + window.scrollY - 120,
      left: rect.left + window.scrollX,
      width: rect.width,
    };
  }

  // 禁止/恢复滚动
  if (jzzsktype.value) {
    document.body.style.overflow = "hidden";
    document.body.style.paddingRight = `${15}px`;
  } else {
    document.body.style.overflow = "";
    document.body.style.paddingRight = `${0}px`;
  }
};

bus.on("knowDataList", (data) => {
  searchQuery.value = data.data;
  getResourceContent("", data.data);
  activeNav.value = "";
});

bus.on("indexKeyWord", (data) => {
  getResourceContent("", data.data);
  searchQuery.value = data.data;
});

// 计算总页数
const totalPages = computed(() => {
  return Math.ceil(counttotal.value / pageSize.value);
});

// 修改handleCurrentChange方法
const handleCurrentChange = (page) => {
  currentPage.value = page;
  // getResourceContent(activeNav.value);
  getResourceContent(activeNav.value, searchQuery.value);
};

const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "7",
      url: weburl.value,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};

const handlecooperation = (data) => {
  router.push({
    name: "cooperation",
  });
};

const stripHtmlTags = (html) => {
  if (!html) return "";
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};
const datebaseinfo = (data) => {
  localStorage.setItem("lastSelectTime", Date.now().toString());
  // router.push({
  //   name: "newDatabaseInfo",
  //   query: { id: data.id },
  // });
  const url = router.resolve({
    name: "newDatabaseInfo",
    query: { id: data.id },
  });
  window.open(url.href, "_blank");
  // sessionStorage.setItem("data", JSON.stringify(data));
};
const tableRowClassName = ({ row, rowIndex }) => {
  return 'custom-row';
};
const headerCellStyle = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    // 第一列
    return "hide-selection-header";
  }
  return "";
};
// 计算已选卡片的数量
const selectedCount = computed(() => {
  return selectedRows.value.length;
});

// 处理表格选择变化
// const handleSelectionChange = (selection) => {
//   selectedRows.value = selection;
//   selectAll.value =
//     selection.length === filteredKnowledgeCards.value.length &&
//     filteredKnowledgeCards.value.length > 0;
// };

const handleall = (all) => {
  console.log(all, "all");
};


// 获取已选中的卡片数据
const getSelectedCardsData = () => {
  return selectedRows.value.map((item) => ({
    knowledgeId: item.id,
    knwoledgeTitle: item.title,
    publishUnit: item.publishUnit,
    knowledgeVersion: "netVersion",
    netVersion: item.netVersion,
    mirrorVersion: item.mirrorVersion,
    netPrice: item.netPrice,
    mirrorPrice: item.mirrorPrice,
    netPrice20: item.netPrice20,
    netPrice50: item.netPrice50,
    netPrice100: item.netPrice100,
    netPrice200: item.netPrice200,
  }));
};
const triggerParentEvent = async (card, event) => {
  bus.emit("sendMsg", {
    message: "Hello from SenderComponent!",
    card,
    event,
    lableBtn: lableBtnRef.value,
  });
};
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
    //     userName.value = user?.realName;;
  }
};

// Token expiration check
const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp && Date.now() >= payload.exp * 1000;
  } catch (e) {
    console.error("Token解析错误:", e);
    return true;
  }
};
const handleNavSelect = async(key) => {  
    await fetchBusinessData(key)
  currentPage.value = 1;
  activeNav.value = key;


   bus.emit("yyluid", {
      message: "首页检索框",
      data: key,
    });

};
const prepareCartData = () => {
  return filteredKnowledgeCards.value
    .filter((item) => item?.id)
    .map((item) => ({
      knowledgeId: item.id,
      knwoledgeTitle: item.title,
      publishUnit: item.publishUnit,
      knowledgeVersion: "netVersion",
      netVersion: item.netVersion,
      mirrorVersion: item.mirrorVersion,
      netPrice: item.netPrice,
      mirrorPrice: item.mirrorPrice,
      netPrice20: item.netPrice20,
      netPrice50: item.netPrice50,
      netPrice100: item.netPrice100,
      netPrice200: item.netPrice200,
    }));
};
const prepareCartData2 = () => {
  return filteredKnowledgeCards.value
    .filter((item) => item?.id)
    .map((item) => ({
      knowledgeId: item.id,
      id: item.id,
      knwoledgeTitle: item.title,
      publishUnit: item.publishUnit,
      knowledgeVersion: "netVersion",
      netVersion: item.netVersion,
      mirrorVersion: item.mirrorVersion,
      netPrice: item.netPrice,
      mirrorPrice: item.mirrorPrice,
      netPrice20: item.netPrice20,
      netPrice50: item.netPrice50,
      netPrice100: item.netPrice100,
      netPrice200: item.netPrice200,
    }));
};
const checkAuth = () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (!token || isTokenExpired(token)) {
    ElMessage.warning("请先登录");
    router.push("/login");
    return false;
  }
  return true;
};

const setCurrent = async (event) => {
  console.log('pppp');
  
  // 检查是否正在进行拖拽，如果正在拖拽则不执行点击事件
  if (isDragging.value) return;

  try {
    // First check token status
    const token = JSON.parse(Cookie.get("token")) || "";
    // if (!token || isTokenExpired(token)) {
    //   ElMessage.warning("请先登录");
    //   // router.push("/login"); // Redirect to login page
    //   return;
    // }

    const selectedData = prepareCartData();
    if (selectedData.length === 0) return;

    const response = await PostUserCarList({ cart: selectedData });
    if (response.success) {
      ElMessage.success("一键加入成功");
      triggerParentEvent(prepareCartData(), event);
    }
  } catch (error) {
    console.error("加入购物车失败:", error);
    if (error.response && error.response.status === 401) {
      ElMessage.warning("登录已过期，请重新登录");
      // router.push("/login");
    } else {
      // console.log( prepareCartData());

      localStorage.setItem(
        "addCardListParams",
        JSON.stringify(prepareCartData2())
      );
      triggerParentEvent(prepareCartData2(), event);
      ElMessage.success(`${prepareCartData2().length}个项目已添加到购物车`);
    }
  }
};
const draggableBtn = ref(null);
let offsetX = 0;
let offsetY = 0;

const startDrag = (e) => {
  isDragging.value = true;
  const rect = draggableBtn.value.getBoundingClientRect();
  offsetX = e.clientX - rect.left;
  offsetY = e.clientY - rect.top;

  // 防止文本选中
  document.body.style.userSelect = "none";
};

const onDrag = (e) => {
  if (!isDragging.value) return;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;
  const btnWidth = draggableBtn.value.offsetWidth;
  const btnHeight = draggableBtn.value.offsetHeight;

  let newX = e.clientX - offsetX;
  let newY = e.clientY - offsetY;

  // 限制X轴位置
  if (newX < 0) {
    newX = 0;
  } else if (newX > windowWidth - btnWidth) {
    newX = windowWidth - btnWidth;
  }

  // 限制Y轴位置
  if (newY < 0) {
    newY = 0;
  } else if (newY > windowHeight - btnHeight) {
    newY = windowHeight - btnHeight;
  }

  draggableBtn.value.style.left = `${newX}px`;
  draggableBtn.value.style.top = `${newY}px`;
};

const stopDrag = () => {
  isDragging.value = false;
  document.body.style.userSelect = "";
};

const handleDragEnd = (e) => {
  e.target.style.opacity = "1";
  // 获取最终位置
  const x = e.clientX;
  const y = e.clientY;
  console.log(`按钮被拖拽到位置: (${x}, ${y})`);
};




onMounted(async () => {
    await fetchBusinessData('396')
    window.addEventListener("mousemove", onDrag);
  window.addEventListener("mouseup", stopDrag);
  await handleNavSelect(activeNav.value)
  //  await checkTokenStatus();
});
onBeforeUnmount(() => {
  window.removeEventListener("mousemove", onDrag);
  window.removeEventListener("mouseup", stopDrag);
});
onUnmounted(async () => {
  await handleLog();

  bus.off("indexKeyWord");
  bus.off("knowDataList");
});
const hiddenTime = ref(Number);
window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "2",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});

const getImagePath2 = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};
</script>

<style scoped>
.knowledge-container {
  display: flex;
  /* margin-bottom: 40px; */
  padding-bottom: 40px;
}

.knowledge-nav {
  width: 210px;
  height: 68px;
  opacity: 1;
  scrollbar-width: none;
  -ms-overflow-style: none;
  /* border-radius: 10px; */
  background: #fff;
  /* border-top-left-radius: 12px;
  border-top-right-radius: 12px; */
  /* background-image: url(@/assets/newimages/zskflnavimg.png); */
  /* background-repeat: no-repeat;
  background-size: cover; */
  border-bottom: 1px solid #e4e7ed;
}

.knowledge-nav::-webkit-scrollbar {
  width: 0;
}

.knowledge-nav::-webkit-scrollbar {
  width: 0; /* 隐藏WebKit浏览器的滚动条 */
}
.nav-title {
  width: 210px;
  height: 61px;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 61px;
  color: rgba(255, 255, 255, 1);
  text-align: left;
  padding-left: 20px;
  /* padding: 20px 0 0 20px ; */
  vertical-align: top;
  background-image: url(@/assets/headerimage/nav2back.png);
}

.nav-menu {
  width: 210px;
  height: auto;
  /* background: #e1ebff; */
  /* border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px; */
  padding-bottom: 3px;
}
.knowledge-cards {
  padding-left: 20px;
  width: calc(100% - 210px);
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
  min-height: 700px;
}

.knowledge-card {
  position: relative;
  width: 580px;
  height: 118px;
  background: #f4f6fa;
  border-radius: 6px;
  margin-left: 10px;
  float: left;
}
.knowledge-card:hover {
  background: #ecf2ff;
  cursor: pointer;
}
.knowledge-card:hover .card-name {
  color: rgba(33, 79, 219, 1);
}
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.card-header div:hover {
  color: #2c77ff;
}
.card-name {
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 21.12px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  vertical-align: top;
}

.card-content {
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 22px;
  color: rgba(153, 153, 153, 1);
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-top: 4px;
  text-align: justify;
}

.card-bottom-buttons {
  position: absolute;
  bottom: 23px;
  left: 26px;
  display: flex;
  justify-content: left;
}
.el-menu {
  border: none;
  border-right: 1px solid #f3f6ff;
}
.nav-menu .el-menu-item.is-active {
  /* background: #eff5ff; */
  background-color: #1c6bfb;
  color: #ffffff;
}
.el-menu-item:hover {
  background-color: #ffffff !important;
  color: #1c6bfb;
}
.is-active:hover {
  background-color: #1c6bfb !important;
  color: #ffffff;
}
.nav-menu .el-menu-item {
  width: 210px;
  height: 48px;
  /* margin: 10px; */
  padding: 10px 30px !important;
  /* border-radius: 4px; */
}
.nav-menu .el-menu-item:first-child {
  margin-top: 15px;
}
.contertext {
  display: flex;
  justify-content: space-between;
}
.contertext2 {
  display: flex;
  justify-content: space-between;
}
.card-titles {
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 1px;
  line-height: 26.4px;
  color: rgba(56, 56, 56, 1);
  text-align: left;
  text-align: left;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-button:hover {
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 23.94px;
  color: rgba(255, 255, 255, 1);
  text-align: center;
  vertical-align: top;
  background: rgba(31, 85, 222, 1);
}
.knowledge-card:hover .card-titles {
  color: rgba(31, 85, 222, 1);
}

.custom-button {
  width: 162px;
  height: 42px;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0px;
  line-height: 23.94px;
  color: rgba(24, 24, 24, 1);
  text-align: center;
  vertical-align: top;
  border-radius: 0;
  background: #fff;
  cursor: pointer;
}

:deep(.custom-menu-item) {
  transition: all 0.3s ease; /* 添加过渡效果 */
}

/* 鼠标悬停状态 */
:deep(.custom-menu-item:hover) {
  background: rgba(255, 255, 255, 0.09);
  box-shadow: 0px 2px 5px rgba(137);
}
.pageClass {
  width: 100%;
  height: 52px;
  background: #fff;
  display: flex;
  justify-content: center;
  margin-bottom: 40px;
  margin-top: 40px;
}
.know_nav {
  width: 210px;
  height: 50px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 16px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  position: relative;
}
.know_nav span {
}

.know_nav:hover {
  /* color: #2c77ff; */
}
.knowIcon {
  position: absolute;
  right: 0;
  top: 0px;
  width: 60px;
  height: 56px;
}
.knowIcon > img {
  width: 60px;
  height: 56px;
}

.fw_list {
  display: flex;
  gap: 12px; /* 按钮间距 */
  margin-top: 10px;
}

.fw_item {
  display: flex;
  align-items: center; /* 垂直居中 */
  gap: 4px; /* 图标和文字间距 */
  cursor: pointer;
}
.fw_item2 .fw_img2 {
  width: 12px;
  height: 12px;
}
.fw_item2 {
  /* width: 14px; */
  /* height: 14px; */
  display: flex;
  align-items: center;
}

.fw_img {
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
}

.fw_name {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #666666;
  line-height: 1; /* 去除默认行高影响 */
}
.fw_name:hover {
  color: #4a78cd;
}

.cbsText {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 12px;
  color: #999999;
  line-height: 17px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.bot_but {
  display: flex;
  justify-content: space-between;
  margin-top: 11px;
}
.but_item {
  display: flex;
  justify-content: space-between;
}
.but_item1 {
  width: 78px;
  height: 32px;
  background: rgba(255, 255, 255, 0);
  border-radius: 4px;
  border: 1px solid #2c77ff;
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2c77ff;
  font-style: normal;
}
.but_item1:hover {
  background: #2c77ff;
  color: #fff;
}
.but_item2 {
  width: 78px;
  height: 32px;
  background: #2c77ff;
  border-radius: 4px;
  line-height: 32px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
  margin-left: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.but_item2:hover {
  background: #2565d9;
}
:deep(.el-card.is-always-shadow),
:deep(.el-card.is-hover-shadow:focus),
:deep(.el-card.is-hover-shadow:hover) {
  box-shadow: none !important;
}
.el-card.is-always-shadow {
  border: none !important;
  box-shadow: none !important;
  margin-left: 10px;
  margin-top: 10px;
}
.kongEmpoty {
  width: 100%;
  /* height: 100%; */
}

.kongEmpotyimg {
  width: 100%;
  height: 100%; /* 确保容器有明确高度 */
  display: flex;
  flex-direction: column; /* 垂直排列子元素 */
  justify-content: center; /* 垂直居中 */
  align-items: center; /* 水平居中 */
  text-align: center; /* 文字水平居中（针对文本容器） */
  margin-top: 115px;
}
.kongEmpotyimg img {
  width: 200px;
  height: 200px;
}
.kongEmpotytext p {
  text-align: center;
  margin-top: 20px;
  color: #333;
  font-size: 14px;
}
.kongEmpotytext p span {
  color: #2c77ff;
  cursor: pointer;
}

.selectbut {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #2c77ff;
  line-height: 34px;
  text-align: left;
  font-style: normal;
  cursor: pointer;
}

.nav-menu .el-menu-item {
  /* background: #2c77ff; */
  /* margin: 10px 10px 0 10px; */
}
.el-checkbox.el-checkbox--large {
  height: 20px;
  display: flex;
  align-items: center;
}

::v-deep .el-table__body tr {
  background-color: var(--el-table-tr-bg-color);
  height: 60px;
}

::v-deep .el-table__header th {
  height: 45px;
  line-height: 45px;
  background: #fafbfc;
}

::v-deep .el-table .even-row {
  background: rgba(242, 242, 242, 0);
  /* cursor: pointer; */
}
::v-deep .el-table .odd-row {
  background: #fafbfc;
  /* cursor: pointer; */
}
::v-deep .el-table.is-scrolling-none th.el-table-fixed-column--left,
::v-deep .el-table.is-scrolling-none th.el-table-fixed-column--right {
  background: #fafbfc;
}
::v-deep .hide-selection-header .cell {
  display: none;
}
.description-text {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 1.5;
  max-height: 3em;
  padding-top: 8px;
}
.tableTitle {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  cursor: pointer;
}
.tableTitle:hover {
  color: #2c77ff;
}
.knowheader {
  text-align: right;
}

.knowdegritem {
  display: flex;
  /* justify-content: space-between; */
  padding: 12px 0px 12px 0;
  /* gap: 15px; */
}
.knowdegList_title {
  display: flex;
  gap: 13px;
  align-items: center;
}
.knowdegList_title p:hover {
  color: #1c6bfb;
  cursor: pointer;
}
.knowdegList_title p {
  font-size: 16px;
  font-weight: 500;
  color: #333333;

}

.knowdegList_title div {
  width: 33px;
  height: 20px;
  background: #f14748;
  font-size: 12px;
  font-weight: 900;
  text-align: center;
  color: #ffffff;
  line-height: 20px;
}
.knoedege_fwfs {
  display: flex;
  gap: 8px;
  margin-top: 11.5px;
}
.knoedege_fwfs div {
  width: 60px;
  height: 24px;
  background: #f7f7f7;
  border: 0.5px solid #e4e7ed;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 22px;
  color: #999999;
}
.knoedege_text_cont {
  width: 741px;
  position: relative;
  margin-left: 15px;
}
.knoedege_text_cont1{
  width: 901px;
}
.knoedege_text_cont::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 1px;
  background-color: #e4e7ed;
  margin-right: -15px;
}
.knowdege_center {
  display: flex;
  justify-content: space-between;
  width: 976px;
}
.knowdege_center1{
  width: 1136px;
}
.but_count {
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  /* text-align: center; */
  padding-left: 24px;
}
.but_addcard {
  width: 120px;
  height: 33px;
  border: 1px solid #f97619;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  line-height: 33px;
  color: #f97619;
  margin-top: 8px;
}
.but_addcard:hover {
  background: #f97619;
  cursor: pointer;
  color: #fff;
}
.knowdege_but {
  width: 180px;
  padding-left: 40px;
}

.icon_but {
  font-size: 12px;
  color: #cacaca;
  width: 14px;
  height: 14px;
  text-align: center;
  line-height: 14px;
  margin-left: 20px;
  border: solid 0.5px #cacaca;
  cursor: pointer;
}

.knoedege_fwfs .knowdege_jianjie {
  width: 36px;
  height: 24px;
  border: 0.5px solid #e4e7ed;
  font-size: 12px;
  font-weight: 400;
  text-align: center;
  color: #666666;
  line-height: 22px;
  padding-left: 4px;
  background: #fff;
}
.knoedege_fwfs .knowdege_jianjie:hover {
  border: 0.5px solid #1c6bfb;
  color: #1c6bfb;
  cursor: pointer;
}
.cpfl_header_icon {
  display: flex;
  align-items: center;
  gap: 7px;
}
.cpfl_header_icon img {
  width: 16px;
  height: 16px;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
}
.zpzsk_Popover {
  z-index: 1000;
  background: white;
  padding: 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  max-width: 400px;
  position: fixed; /* 或者 absolute */
}

.jpzsk_title {
  padding-bottom: 20px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}
.zpzsk_Popover .jpzsk_content {
  font-size: 14px;
  color: #333;
}


::v-deep .el-table .cell {
  padding: 0;
  padding-left: 10px;
}
:v-deep .el-table .el-table__cell{
  padding: 0;
}

.el-table .custom-row:hover > td {
  background-color: red !important;
}

.draggable-btn {
  position: fixed;
  right: 30px;
  bottom: 400px;
  width: 226px;
  height: 107px;
  /* border-radius: 50%; */
  /* background-color: #2c77ff; */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: move;
  /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2); */
  z-index: 1000;
  transition: opacity 0.3s;
  background-image: url(@/assets/headerimage/yjjrcard01.png);
  background-size: cover;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 15px;
  color: #333333;
  line-height: 21px;
  text-align: center;
  font-style: normal;
  /* cursor: pointer; */
}
.draggable-btn p {
  font-size: 15px;
  color: #333333;
  width: 78px;
  margin-left: 50px;
  cursor: pointer;
}
.draggable-btn :hover {
  color: #2c77ff;
}
</style>
